// Remove o shell estático da landing (overlay criado pelo script #landing-shell-script em
// public/index.html). Seguro de chamar mesmo sem shell (desktop, outros canais, testes).
//
// Quando o CSS da Mondrian está carregando de forma assíncrona (window.mondrianCssPending, ver o
// <head> do index.html) o shell fica até o evento "mondrian-css-ready": removê-lo antes mostraria a
// página sem estilo. O timeout de 15 s do próprio script do shell é a rede de segurança.
const removeNow = () => {
  const shell = document.getElementById("landing-shell");
  if (shell && shell.parentNode) shell.parentNode.removeChild(shell);
};

const removeLandingShell = () => {
  if (window.mondrianCssPending) {
    const onReady = () => {
      window.removeEventListener("mondrian-css-ready", onReady);
      removeNow();
    };
    window.addEventListener("mondrian-css-ready", onReady);
    return;
  }
  removeNow();
};

export default removeLandingShell;
